import { render, staticRenderFns } from "./AppVerifyEmail.vue?vue&type=template&id=818aa492&scoped=true&"
import script from "./AppVerifyEmail.ts?vue&type=script&lang=ts&"
export * from "./AppVerifyEmail.ts?vue&type=script&lang=ts&"
import style0 from "./AppVerifyEmail.scss?vue&type=style&index=0&id=818aa492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818aa492",
  null
  
)

export default component.exports